const LABELS = {
  garanti: 'Garanti',
  not1: 'M. Memnuniyeti',
  teklif: 'Teklif',
  yedek_parca: 'Toplu YP',
  sozlesme: 'B. Sözleşmesi',
  agir_bakim: 'A. Bakım',
  agir_tamir: 'A. Tamir',
  revizyon_guncelleme: 'Rev.-Güncelleme',
  rektifiye: 'A. Bakım',
};

/** Filtre dropdown — tüm tipler (sayfa verisine bağlı değil). */
export const TEKLIF_TIP_FILTER_NAMES = Array.from(new Set(Object.values(LABELS)));

export function formatTeklifTipi(tip) {
  const key = String(tip || 'teklif').trim().toLowerCase();
  return LABELS[key] || tip || 'Teklif';
}
